export default "__VITE_ASSET__qSOvom8m__"